module.exports = __webpack_public_path__ + "static/media/british-virgin-islands.7742865b.svg";